import {
  IGoal,
  IPdpPure,
  PdpStatus,
  GoalType,
  GoalChatMessageType,
} from './../models/Pdp'
import { ICompanyMember, ICompanyPure } from '../models/Company'
import { adaptBackendCompanyToFrontendCompany } from '../../context/services/loadCompany.service'

// More goals can be added until evaluations start
export const canMoreGoalsBeAddedInPdp = (pdp: IPdpPure): boolean => {
  return [PdpStatus.DRAFTING, PdpStatus.PUBLISHED].includes(pdp.status)
}

// Notes can always be left in chat *for now*
export const canMoreMessagesBeSentInPdpChat = (): boolean => {
  return true
}

// Goals can be added and edited until evaluations start
export const canMoreGoalsBeAddedOrModifiedInPdp = (pdp: IPdpPure): boolean => {
  return [PdpStatus.DRAFTING, PdpStatus.PUBLISHED].includes(pdp.status)
}

// Goals can be removed only during draft
export const canGoalsBeDeletedFromPdp = (pdp: IPdpPure): boolean => {
  return [PdpStatus.DRAFTING].includes(pdp.status)
}

// Reviews available only while the pdp is published, until evaluations start
export const canGoalReviewBeRequested = (pdp: IPdpPure): boolean => {
  return [PdpStatus.PUBLISHED].includes(pdp.status)
}
// Can be edited until evaluations start
export const canGoalsBeModifiedInPdp = (pdp: IPdpPure): boolean => {
  return [PdpStatus.DRAFTING, PdpStatus.PUBLISHED].includes(pdp.status)
}

export const hasGoalActiveNotifications = (
  member: ICompanyMember,
  isOwnProfile: boolean,
  goal: IGoal
): boolean => {
  const numberOfUnopenedMessages = (pdpGoal: IGoal): number => {
    if (
      !isOwnProfile ||
      !pdpGoal.messages ||
      !pdpGoal.messages.some(
        (message) => message.messageType === GoalChatMessageType.SIMPLE_MESSAGE
      )
    ) {
      return 0
    }
    const unread = pdpGoal.messages.filter(
      (message) =>
        message.messageType === GoalChatMessageType.SIMPLE_MESSAGE &&
        !message.dateOpened &&
        message.senderId + '' !== member._id + ''
    )
    return unread.length || 0
  }

  return numberOfUnopenedMessages(goal) > 0
}

export const areGoalsEnoughToProceedAfterDraft = (
  pdp: IPdpPure,
  company?: ICompanyPure
): boolean => {
  const habitGoals = pdp.goals.filter((goal) => goal.type === GoalType.HABIT)
    .length
  const skillGoals = pdp.goals.filter((goal) => goal.type === GoalType.SKILL)
    .length
  const requiredSkillGoals =
    company?.goalsConfig?.requiredSkillGoals === undefined
      ? 2
      : Number(company?.goalsConfig?.requiredSkillGoals)
  const requiredCultureGoals =
    company?.goalsConfig?.requiredCultureGoals === undefined
      ? 2
      : Number(company?.goalsConfig?.requiredCultureGoals)

  const convertedCompany =
    company && adaptBackendCompanyToFrontendCompany(company)

  const member = convertedCompany?.members.find(
    (m) => m._id + '' === pdp.memberId + ''
  )

  if (
    member &&
    member.jobLevel &&
    (!member.jobLevel.skills || member.jobLevel.skills.length === 0)
      ? habitGoals >= requiredCultureGoals
      : habitGoals >= requiredCultureGoals && skillGoals >= requiredSkillGoals
  ) {
    return true
  }

  return false
}
